import { Brand, make } from 'shared/types/brand';
export type TranslatedString = Brand<string, 'TranslatedString'>;

/** Brands a string as already translated — use only in the intl layer. */
export const asTranslatedString = make<TranslatedString>();
